//
// Copyright 2026 DXOS.org
//

/**
 * Increment for a number field's stepper buttons and arrow keys. Here rather than in the form package so a
 * model schema can declare it without depending on React.
 */
export const StepAnnotationId = '@dxos/schema/annotation/Step';
